//Props Validations
import PropTypes from "prop-types";

//redux
import { useSelector } from "react-redux";
function DriverAnalysisSummary({ studyPeriod = "", studyRef = "", targetKpi = "", identifier = "", rSquaredValue = "", plsVarianceValues = {}, algorithm = "" }) {
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellBeing = isHairCare || isSkinCare;
    console.log(algorithm)
    return (
        <span
            className="ps-2"
            style={{ fontSize: "14px", color: "#005eef", padding: "10px 0px", alignItems: "baseline", display: "flex" }}
        >
            <>
                <span
                    className="ps-2 pe-0 text-bold-6"
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    Product Category:&nbsp;
                </span>
                <span
                    className="ps-0 pe-3 text-bold-5"
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    {productCategoryData.label}
                </span>
                <span
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    |
                </span>
            </>
            <>
                <span
                    className="ps-2 pe-0 text-bold-6"
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    Identifier:&nbsp;
                </span>
                <span
                    className="ps-0 pe-3 text-bold-5"
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    {identifier}
                </span>
                <span
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    |
                </span>
            </>
            <>
                <span
                    className="ps-2 pe-0 text-bold-6"
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    Study Period:&nbsp;
                </span>
                <span
                    className="ps-0 pe-3 text-bold-5"
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    {studyPeriod}
                </span>
                <span
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    |
                </span>
            </>
            <>
                <span
                    className="ps-2 pe-0 text-bold-6"
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    Study Reference:&nbsp;
                </span>
                <span
                    className="ps-0 pe-3 text-bold-5"
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    {studyRef}
                </span>
                <span
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    |
                </span>
            </>
            <>
                <span
                    className="ps-2 pe-0 text-bold-6"
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    Target KPI:&nbsp;
                </span>
                <span
                    className="ps-0 pe-3 text-bold-5"
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    {targetKpi}
                </span>
                <span
                    style={{
                        margin: "auto 0px",
                    }}
                >
                    |
                </span>
            </>
            {(isBeautyAndWellBeing || isUnileverFragranceHouse)&& (
                <>
                    {algorithm === "partial_least_squares" && (
                        <>
                            <span
                                className="ps-2 pe-0 text-bold-6"
                                style={{
                                    margin: "auto 0px",
                                }}
                            >
                                Predictor Matrix (X%):&nbsp;
                            </span>
                            <span
                                className="ps-0 pe-3 text-bold-5"
                                style={{
                                    margin: "auto 0px",
                                }}
                            >
                                {plsVarianceValues?.x_variance ?? "-"}
                            </span>
                            <span
                                className="ps-2 pe-0 text-bold-6"
                                style={{
                                    margin: "auto 0px",
                                }}
                            >
                                | Response Matrix (Y%):&nbsp;
                            </span>
                            <span
                                className="ps-0 pe-3 text-bold-5"
                                style={{
                                    margin: "auto 0px",
                                }}
                            >
                                {plsVarianceValues?.y_variance ?? "-"}
                            </span>
                            <span
                                className="ps-2 pe-0 text-bold-6"
                                style={{
                                    margin: "auto 0px",
                                }}
                            >
                                | R Squared:&nbsp;
                            </span>
                            <span
                                className="ps-0 pe-3 text-bold-5"
                                style={{
                                    margin: "auto 0px",
                                }}
                            >
                                {rSquaredValue ? (rSquaredValue.toString().includes('%') ? rSquaredValue : `${Number.parseFloat(rSquaredValue).toFixed(2)}%`) : "-"}
                            </span>
                        </>
                    )}
                    {algorithm === "relative_weight_analysis" && (
                        <>
                            <span
                                className="ps-2 pe-0 text-bold-6"
                                style={{
                                    margin: "auto 0px",
                                }}
                            >
                                R Squared:&nbsp;
                            </span>
                            <span
                                className="ps-0 pe-3 text-bold-5"
                                style={{
                                    margin: "auto 0px",
                                }}
                            >
                                {rSquaredValue ? (rSquaredValue.toString().includes('%') ? rSquaredValue : `${Number.parseFloat(rSquaredValue).toFixed(2)}%`) : "-"}
                            </span>
                        </>
                    )}
                </>
            )}
        </span>
    );
}

// Typechecking props for the AgreementKpi
DriverAnalysisSummary.propTypes = {
    studyRef: PropTypes.string,
    studyPeriod: PropTypes.string,
    targetKpi: PropTypes.string,
    identifier: PropTypes.string,
    rSquaredValue: PropTypes.string,
    plsVarianceValues: PropTypes.object,
    algorithm: PropTypes.string,
};

export default DriverAnalysisSummary;
